import {
    Directive, ElementRef, Renderer2, HostListener, Input, AfterViewInit,
    OnChanges, SimpleChanges, Optional, Self
} from '@angular/core';
import * as _ from 'underscore';
import { AppConstants } from 'app/app.constants';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[form],form',
    standalone: false
})
export class EnterKeyListenerDirective implements AfterViewInit, OnChanges {

    // tslint:disable-next-line:max-line-length
    toSearch = AppConstants.toSearch;
    @Input() formGroup: UntypedFormGroup;
    @Input() flag: boolean;
    @Input() id = 0;
    count = 0;

    constructor(
        private readonly el: ElementRef,
        private renderer: Renderer2
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.el.nativeElement.focus();
    }

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.altKey && event.key === 'Escape') {
            const fields = this.getFormFields();
            if (fields && fields.length) {
                if (+this.id === 0) {
                    fields[0].focus();
                }
            }
        }
    }

    ngAfterViewInit() {
        const fields = this.getFormFields();
        if (fields && fields.length) {
            fields[0].focus();
        }
    }

    @HostListener('keydown', ['$event'])
    keyDown(event: KeyboardEvent) {
        // event.stopPropagation();
        this.el.nativeElement.focus();
        if (event.key === 'Enter' && (event.target as HTMLElement).tagName !== 'TEXTAREA') {
            event.preventDefault();
            this.focusTonextElementInForm(event.target as HTMLElement);
        }
    }

    focusTonextElementInForm(activeElement: HTMLElement) {
        const fields = this.getFormFields();

        // Find if the active element is inside another field
        let currentEl = activeElement;
        let parentInFields = null;

        for (const field of fields) {
            if (field.contains(activeElement) && field !== activeElement) {
                parentInFields = field;
                break;
            }
        }

        // Use the parent element if found, otherwise use the active element
        currentEl = parentInFields || activeElement;

        // Find the index of the current element
        const index = fields.indexOf(currentEl);

        if (index === -1) {
            fields[0].focus();
        } else if (index > -1 && (index + 1) <= fields.length) {
            const nextIndex = ((index + 1) === fields.length) ? 0 : index + 1;
            fields[nextIndex].focus();
        }
    }

    // Adding this alias method for backward compatibility
    focusToNextElementInForm(activeElement: HTMLElement) {
        return this.focusTonextElementInForm(activeElement);
    }

    focusFirstElement(timeout = 100) {
        setTimeout(() => {
            const fields = this.getFormFields();
            if (fields.length > 0) {
                fields[0].focus();
            }
        }, timeout);
    }

    private getFormFields(): HTMLElement[] {
        // Use querySelector to find the elements instead of jQuery
        return Array.from(this.el.nativeElement.querySelectorAll(this.toSearch));
    }
}